import type { InputHTMLAttributes, Ref } from 'react';

import React from 'react';

import CheckboxContainer from './CheckboxContainer';
import ErrorMessage from './ErrorMessage';
import StyledCheckmark from './StyledCheckmark';
import StyledInput from './StyledInput';
import StyledLabel from './StyledLabel';

export interface ICheckboxInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string | React.ReactNode;
  containerProps?: object;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

const CheckboxInput = React.forwardRef(
  (
    {
      label,
      containerProps,
      error,
      errorMessage,
      ...props
    }: ICheckboxInputProps,
    ref: Ref<HTMLInputElement>
  ) => (
    <div style={{ marginBottom: '24px' }}>
      <CheckboxContainer
        error={error}
        errorMessage={errorMessage}
        {...containerProps}
        role={'checkbox'}
        name={props.name}
      >
        <StyledInput type="checkbox" {...props} ref={ref} />
        <StyledCheckmark error={error} />
        <StyledLabel>{label}</StyledLabel>
        {error && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </CheckboxContainer>
    </div>
  )
);

const defaultProps = {
  containerProps: {},
  error: false,
};

CheckboxInput.defaultProps = defaultProps;

export default CheckboxInput;
